import { FormattedMessage, useIntl } from 'react-intl';

import { CloseIcon } from '@/components/icons/close';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';

type ClearFiltersButtonProps = {
  count: number;
  onClick: () => void;
};

/** Dashed "Clear (n)" control shown when search, sort, or filters are active. */
export function ClearFiltersButton({
  count,
  onClick,
}: ClearFiltersButtonProps) {
  const intl = useIntl();

  if (count <= 0) return null;

  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      className="border-fx-neutral-200 rounded-lg border-dashed"
      aria-label={intl.formatMessage(
        {
          defaultMessage: 'Clear {count} applied filters',
          description:
            'Accessible label for clearing table search, sort, and filters',
        },
        { count },
      )}
    >
      <Typography variant="body1">
        <FormattedMessage
          defaultMessage="Clear ({count})"
          description="Filter bar: clear search, sort, and all applied filters; count is how many are active"
          values={{ count }}
        />
      </Typography>
      <CloseIcon className="text-fx-neutral-400 size-4" />
    </Button>
  );
}
